import { render, staticRenderFns } from "./layout-category-header.vue?vue&type=template&id=733d55cc&scoped=true"
import script from "./layout-category-header.vue?vue&type=script&lang=js"
export * from "./layout-category-header.vue?vue&type=script&lang=js"
import style0 from "./layout-category-header.vue?vue&type=style&index=0&id=733d55cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733d55cc",
  null
  
)

export default component.exports